/* eslint-disable @typescript-eslint/naming-convention */

export const commercialConstants = {
    logEventIds: {
        paymentPageEventId: '406800118',
        makePaymentEventId: '406800121',
        quickIdSearchEventId: '405810092',
        quickIdViewEventId: '405810094',
        coiRequestSelectPageEventId: '406800280',
        coiRequestReviewPageEventId: '406800281',
        coiRequestConfirmPageEventId: '406800282',
        coiRequestLetterPageEventId: '406800283',
        paymentPageNoSavedPrefsEventId: '406800116',
        paymentPageHasSavedPaymentMethodsEventId: '406800117',
        printConfirmationPageEventId: '406800122',
        enrollAutoPayEventId: '406800099',
        loadAutoPayReviewPageEventId: '406800100',
        submitAutoPayEnrollmentEventId: '406800101',
        printAutoPayEnrollConfirmationPageEventId: '406800102',
        myLossControlEventDataId: '406800289',
        loadAutoPayConfirmationPageEventId: '406800103',
        viewAllPaymentsLinkEventId: '406800285',
        viewAllBillsLinkEventId: '406800284',
        billingPdfEventDataId: '406800078',
        onLoadOfBillingStatementPdfEventDataId: '406800079',
        printBillingDetailsPageEventDataId: '406800080',
        onLoadOfBusinessBillingDetailsEventDataId: '406800286',
        myNSightEventDataId: '406800288',
        onClickViewPrintCoiCurrentPolicyDocumentsEventId: '406800290',
        onLoadOfDocumentPdfEventId: '406800128',
        EditAutoPayEventId: '406800104',
        EditAutoPaySubmitEventId: '406800106',
        SubmitAutoPayEditEventId: '406800107',
        LoadAutoPayEditConfirmationPageEventId: '406800108',
        printAutoPayEditConfirmationPageEventId: '406800109',
        CancelAutoPayEventId: '406800110',
        SubmitAutoPayCancelEventId: '406800112',
        printAutoPayCancelConfirmationPageEventId: '406800113',
        SuspendAutoPayEventId: '406800206',
        SuspendAutoPayPayNowOrLaterEventId: '406800207',
        SuspendAutoPayConfirmationEventId: '406800309',
        SuspendAutoPayCancelEventId: '406800311',
        printAutoPaySuspendConfirmationEventId: '406800310',
        AuthAgreementEventId: '406800123',
        AcceptAuthAgreementEventId: '406800124',
        clickToChatSend: '406800265',
        bankAccountDeclineResponseId: '406800360',
        // commercial claims
        LoadPAKClaimsListEventId: '405810106',
        LoadPolicyClaimsListEventId: '405810001',
        StartAGlassClaimEventId: '405810003',
        StartAClaimEventId: '405810004',
        UniqueUsersOnClaimsOverviewEventId: '405810007',
        UniqueUsersOnAllUpdatesEventId: '405810047',
        UniqueUsersOnDetailsDocumentsEventId: '405810010',
        UniqueUsersOnPaymentsEventId: '405810011',
        UniqueUsersOnContactsEventId: '405810021',
        SubmitSuccessToConfirmationEventId: '405810034',
        LoadConfirmationEventId: '405810036',
        LoadSoftfallEventId: '405810043',
        SearchingForClaimEventId: '405810110',
        countNoOfUsersToAddOrEditPaymentMethod: '406800357'
    },
    coiDates: {
        fromDateToDate: '&from=2015-08-01&to=2018-08-31'
    },
    tridionProperties: [
        {
            types: ['header', 'footer', 'paymentStatus'],
            file: '/group1.json'
        },
        {
            types: ['helpText'],
            file: '/group2.json'
        },
        {
            types: ['icons', 'billing', 'RequestLiabilityCOI', 'automaticPayments'],
            file: '/group4.json'
        }
    ],
    logEventProperties: {
        contentType: 'application/json',
        appId: 'NW-CSS',
        accept: 'application/json',
        appCookie: 'Internet Servicing Commercial',
        unauthenticatedClientType: 'Unauthenticated',
        authenticatedClientType: 'Authenticated',
        printConfirmationPageEventDescription: 'Number of customers who print confirmation page for pay bill',
        billingPdfEventDataDescription: 'Number of times a billing PDF statement was accessed from Billing Details',
        onLoadOfBillingStatementPdfEventDataDescription: 'Count of customer accessing billing statement PDF from Billing Details',
        printBillingDetailsPageEventDataDescription: 'Number of times customer selects Printer friendly link from billing details',
        onLoadOfBusinessBillingDetailsEventDataDescription: 'Number of customers who are landing on business billing details page',
        myNSightEventDataDescription: 'Number of customers who click MyNSight button',
        lossControlEventDescription: 'Number of customers who click MyLossControlServices button',
        sourceSystem: 'Flex',
        paymentPageEventDescription:
            'Number of customers who complete input page of Payment',
        paymentPageWithPMOFEventDescription: 'Number of customers who want to pay their bill using preferences',
        ecn: 'ecif.ecn',
        productType: 'Commercial',
        ip: 'client.ip',
        state: 'ecif.state',
        agreement_role: 'jwt.agreement_role',
        enrollAutoPayEventDescription: 'Number of customers selecting to enroll in automatic payments',
        loadAutoPayReviewPageEventDescription: 'Number of customers on the auto pay enrollment review page with payment type',
        submitAutoPayEnrollmentEventDescription: 'Track number of customers who completed the automatic payment enrollment process',
        printAutoPayEnrollConfirmationPageEventDescription: 'Number of customers who print auto pay enroll confirmation page',
        loadAutoPayConfirmationPageEventDescription: 'Number of customers who got confirmation/failure on enrollment into EasyPay',
        coiSelectPageEventDescription: 'Number of customers who land on Request Liability Coi page',
        coiReviewPageEventDescription: 'Number of customers who land on Review certificate request Coi page',
        coiConfirmPageEventDescription: 'Number of customers who loaded the COI confirmation page',
        coiRequestLetterPageEventDescription: 'COI request letter has been successfully uploaded',
        viewAllPaymentsLinkEventDescription: 'Number of customers click on View all payments on payment history',
        viewAllBillsLinkEventDescription: 'Number of customers click on View all bills on billing history',
        onClickViewPrintCoiCurrentPolicyDocumentsEventDescription: 'Number of customers click on ViewPrint COI on current policy documents',
        onLoadOfDocumentPdfEventDescription: 'Customer has loaded document to View/Print',
        EditAutoPayEventDescription: 'Number of customers who Edit Easypay',
        EditAutoPaySubmitEventDescription: 'Number of customers who edit financial info or switch payment method for EasyPay',
        SubmitAutoPayEditEventDescription: 'Number of customers who completed Edit EasyPay Process',
        LoadAutoPayEditConfirmationPageEventDescription: 'Number of customers who got confirmation/failure on Manage EasyPay',
        printAutoPayEditConfirmationPageEventDescription: 'Number of customers who print Edit Easypay Confirmation',
        CancelAutoPayEventDescription: 'Number of customers who Cancel Easy Pay',
        SubmitAutoPayCancelEventDescription: 'Track number of customers who confirmed cancellation of EasyPay',
        printAutoPayCancelConfirmationPageEventDescription: 'Number of customers printing cancel EasyPay confirmation page',
        AcceptAuthAgreementEventDescription: 'Track the number of customers who agreed to the Authorization Form',
        SuspendAutoPayEventDescription: 'Count customers that go to the suspend landing page and the URL they came from',
        SuspendAutoPayNowLaterEventDescription: 'Track customers that have suspended autopay and choose to pay now or later',
        SuspendAutoPayConfirmationEventDescription: 'Track the number of customers who land on the confirmation page',
        SuspendAutoPayCancelEventDescription: 'Track the number of customers who cancel the suspend transaction',
        printAutoPaySuspendConfirmationEventDescription: 'Track the number of customers who print the Suspend confirmation page',
        guid: 'jwt.guid',
        userId: 'jwt.userId',
        addOrEditSavedPaymentMethodEventDescription: 'Count No of users that add or edit a payment method on the paybill landing page',
        bankAccountDeclineDescription: 'Bank verification service response - unacceptable response code returned'
    },
    ctmEventProperties: {
        sourceSystemFlex: 'Flex',
        sourceSystemPAK: 'PAK',
        sourceSystemCLD: 'CL Direct PolicyCenter Account',
        mappingIdFlex: 'InternetServicing-0018',
        mappingIdCLD: 'InternetServicing-0028'
    },
    searchPageErrors: {
        NoRemainingBalance: {
            message:
                'You have no payment due at this time.  Please Log in/Sign up to view your account information',
            type: 'danger'
        },
        server_error: {
            message:
                'We cannot locate an account associated with this information. ' +
                'Please check the information below and try again, or Log in/Sign up for an online account to make your payment.',
            type: 'danger'
        },
        access_denied: {
            message:
                'We cannot locate an account associated with this information. ' +
                'Please check the information below and try again or Log in to make your payment.',
            type: 'danger'
        },
        quickid_access_denied: {
            message:
                'We cannot locate an account associated with this information. ' +
                'Please check the information below and try again, or Log in/Sign up for an online account to view your ID card.',
            type: 'danger'
        },
        RecurringPayment: {
            message:
                'You are currently signed up for automatic payments.  Please Log in/ Sign up to manage your payment preferences',
            type: 'danger'
        },
        SessionExpired: {
            message: 'Your session has expired. Please try again',
            type: 'info'
        },
        QuickIdInvalidPrefixB: {
            message: 'Please enter a valid business policy number. To request documents for other policy types, ' +
                '<a href="{{ LOG_IN }}">log in</a> to your Nationwide account.',
            type: 'danger'
        },
        QuickIdDownloadFailure: {
            message: 'We\'re sorry! A system error has occurred. Please ' +
                '<a href="{{ LOG_IN }}">log in to your account</a> to access your ID card(s)',
            type: 'danger'
        },
        QuickIdNoDocuments: {
            message: 'No Id cards found. Please ' +
                '<a href="{{ LOG_IN }}">log in to your account</a> to access your ID card(s)',
            type: 'danger'
        },
        authTimeout: {
            message:
                'An error occurred while processing your request. Please try again later.',
            type: 'danger',
            timeoutLength: 60000
        }
    },
    timeout: {
        excludedRoutes: ['/quickPay/search', '/quickIdCards']
    },
    paymentPageErrors: {
        InvalidRoutingNumber: 'Invalid bank routing number'
    },
    farmingPrefixes: ['FPK', 'FPKN'],
    states: [
        'AK',
        'AL',
        'AR',
        'AZ',
        'CA',
        'CO',
        'CT',
        'DC',
        'DE',
        'FL',
        'GA',
        'HI',
        'IA',
        'ID',
        'IL',
        'IN',
        'KS',
        'KY',
        'LA',
        'MA',
        'MD',
        'ME',
        'MI',
        'MN',
        'MO',
        'MS',
        'MT',
        'NC',
        'ND',
        'NE',
        'NH',
        'NJ',
        'NM',
        'NV',
        'NY',
        'OH',
        'OK',
        'OR',
        'PA',
        'RI',
        'SC',
        'SD',
        'TN',
        'TX',
        'UT',
        'VA',
        'VT',
        'WA',
        'WI',
        'WV',
        'WY'
    ],
    months: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12'
    ],
    hours: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12'
    ],
    minutes: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24',
        '25',
        '26',
        '27',
        '28',
        '29',
        '30',
        '31',
        '32',
        '33',
        '34',
        '35',
        '36',
        '37',
        '38',
        '39',
        '40',
        '41',
        '42',
        '43',
        '44',
        '45',
        '46',
        '47',
        '48',
        '49',
        '50',
        '51',
        '52',
        '53',
        '54',
        '55',
        '56',
        '57',
        '58',
        '59'
    ],
    paymentMethods: {
        cardGroup: 'Credit Card',
        bankGroup: 'EFT'
    },
    paymentMethodOptions: [
        { title: 'Bank account', value: 'bankGroup' },
        { title: 'Credit/Debit card', value: 'cardGroup' }
    ],
    savePaymentMethodOptions: [
        { title: 'New Checking/Savings account', value: 'bankGroup' },
        { title: 'New Credit/Debit card', value: 'cardGroup' }
    ],
    enrollPaymentMethodOptions: [
        { title: 'New Bank account', value: 'bankGroup' },
        { title: 'New Credit/Debit card', value: 'cardGroup' }
    ],
    paymentMethodGroups: {
        BANK: 'bankGroup',
        CARD: 'cardGroup'
    },
    regexValidators: {
        positiveDecimal: /^[0-9]*\.?[0-9]*$/,
        positiveInteger: /^\d+$/,
        isNumeric: /^[0-9]*$/,
        isAlphaNumeric: /^[a-zA-Z0-9\s]*$/,
        isAlphaNumericWithHyphens: /^[a-zA-Z0-9\s-]*$/,
        isAlpha: /^[a-zA-Z\s]*$/,
        isAlphaNoSpaces: /[a-zA-Z]+/,
        startsWithAlpha: /^[a-zA-Z]/,
        nameField: /^[a-zA-Z\s'.,-]*$/,
        addressField: /^[a-zA-Z0-9\s./-]*$/,
        // eslint-disable-next-line no-useless-escape
        isValidEmail: /^[\w-\.\+]+@([\w-]+\.)+[\w-]{2,4}$/,
        mutipleEmail: /^(([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3})(\s*,\s*|\s*$)){1,2}$/,
        isValidPhoneNumber: /^\d{3}-?\d{3}-?\d{4}$/,
        // eslint-disable-next-line no-useless-escape
        bankAccountHolderName: /^[A-Za-z\-\'\s\,\.]+$/,
        dateOfBirth: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/
    },
    documentErrors: {
        documentUnavailable: 'The document that you are looking for is currently unavailable.' +
            ' If you need further assistance, please contact your agent or call 1-877-669-6877',
        cldDocumentUnavailable: 'The document that you are looking for is currently unavailable.' +
            ' If you need further assistance please call 1-888-508-8622.'
    },
    // TODO: Add CL policy center prefix A's. Leave FPKN before FPK
    quickIdPrefixBList: ['BA', 'BPA'],
    transa: 'TRANSA',
    coiTransa: 'COI',
    nwRepoId: 'DSMPROD',
    accnt: 'ACCNT',
    policyNo: 'POLICYNO',
    policy: 'Policy',
    policyInfo: [
        {
            prefixes: ['BA'],
            display: 'Business Auto',
            tridionIdentifier: 'businessAuto'
        },
        {
            prefixes: ['BPA', 'BPAF'],
            display: 'Businessowners',
            tridionIdentifier: 'autoService'
        },
        {
            prefixes: ['BPF'],
            display: 'Businessowners',
            tridionIdentifier: 'foodservice'
        },
        {
            prefixes: ['BPH'],
            display: 'Businessowners',
            tridionIdentifier: 'habitational'
        },
        {
            prefixes: ['BPM'],
            display: 'Businessowners',
            tridionIdentifier: 'hotel'
        },
        {
            prefixes: ['BPO', 'BP01'],
            display: 'Businessowners',
            tridionIdentifier: 'office'
        },
        {
            prefixes: ['BPS'],
            display: 'Businessowners',
            tridionIdentifier: 'processService'
        },
        {
            prefixes: ['BPR'],
            display: 'Businessowners',
            tridionIdentifier: 'retail'
        },
        {
            prefixes: ['BPW'],
            display: 'Businessowners',
            tridionIdentifier: 'wholesalers'
        },
        {
            prefixes: ['CA', 'FAEV'],
            display: 'Commercial Umbrella',
            tridionIdentifier: 'commercialUmbrella'
        },
        {
            prefixes: ['CIM', 'FIMV'],
            display: 'Inland Marine',
            tridionIdentifier: 'commercialInlandMarine'
        },
        {
            prefixes: ['CO'],
            display: 'Commercial Output',
            tridionIdentifier: 'commercialOutput'
        },
        {
            prefixes: ['CP', 'EQ', 'GP'],
            display: 'Commercial Property',
            tridionIdentifier: 'commercialProperty'
        },
        {
            prefixes: ['CR'],
            display: 'Crime',
            tridionIdentifier: 'crime'
        },
        {
            prefixes: ['FAEN'],
            display: 'Farm Umbrella',
            tridionIdentifier: 'farmUmbrella'
        },
        // Probably need a farm property here
        // Also missing fire
        {
            prefixes: ['FMPA', 'FMPP', 'FMP', 'FLC', 'FLA', 'FL', 'GLNO', 'LM', 'BTFA', 'BTFC', 'FMPV'],
            display: 'Farm',
            tridionIdentifier: 'farmLiability'
        },
        {
            prefixes: ['GL'],
            display: 'General Liability',
            tridionIdentifier: 'generalLiabilityCommercial'
        },
        {
            prefixes: ['WC'],
            display: 'Workers Compensation',
            tridionIdentifier: 'workersComp'
        }
    ],
    billing: {
        mortgageBill: 'Mortgage Bill',
        billPayments: 'Bill & Payments'
    },
    billingDocumentTransaCodes: ['BILL', 'BILLING', 'NOC', 'CLD EFT', 'CLD NOC', 'CLD 3P LETTERS', 'CANCELLED'],
    billingStatuses: {
        amountDue3rdParty: 'amountDue3rdParty',
        amountDueFullPay: 'amountDueFullPay',
        amountDueWithFees: 'amountDueWithFees',
        easyPayDeductionScheduledHeader: 'easyPayDeductionScheduledHeader',
        paymentStatus3rdPartyPaid: 'paymentStatus3rdPartyPaid',
        paymentStatusNoBalHeader: 'paymentStatusNoBalHeader',
        paymentStatusPaid: 'paymentStatusPaid',
        paymentStatusPastDue: 'paymentStatusPastDue',
        paymentStatusReceived: 'paymentStatusReceived',
        paymentStatusNrbPastDueHeader: 'paymentStatusNrbPastDueHeader',
        paymentStatusNrbReceivedHeader: 'paymentStatusNrbReceivedHeader',
        paymentStatusRbReceivedHeader: 'paymentStatusRbReceivedHeader',
        pleaseContactAgent: 'pleaseContactAgent',
        pleaseMakePaymentCurrency: 'pleaseMakePaymentCurrency',
        policyStatus: 'policyStatus'
    },
    paymentDetails: {
        completedPaymentIndex: 4,
        duplicatePaymentIndex: 2,
        paymentErrorIndex: 3,
        paymentAmountIndex: 0,
        paymentDateIndex: 1
    },
    viewDocuments: {
        numberOfDocuments: 15,
        documentPakValue: 'pak',
        documentPolicyValue: 'policy',
        insuranceIdCardTransaCodes: [
            'REPRINT - ID CARDS',
            'RENEWAL - ID CARDS',
            'NEW BUSINESS - ID CARDS',
            'AMENDMENT - ID CARDS',
            'REPRINT-ID CARDS',
            'RENEWAL-ID CARDS',
            'NEW BUSINESS-ID CARDS',
            'AMENDMENT-ID CARDS'
        ],
        policyDecTransaCodes: ['REPRINT', 'RENEWAL', 'NEW BUSINESS', 'REISSUE']
    },
    buttonConstants: {
        cancel: 'Cancel',
        enrollAuto: 'Enroll in Automatic Payments',
        setUpAuto: 'Set Up Automatic Payments',
        submit: 'Submit',
        back: 'Back'
    },
    paymentMethod: {
        EFT: 'EFT.PaymentDetails',
        BANKCARD: 'CreditCard.PaymentDetails'
    },
    savePaymentMethod: {
        checkBoxLabel: 'Save this payment method'
    },
    recurringPaymentMethod: {
        EFT: 'EFT.PaymentMethodDetails',
        BANKCARD: 'BankCard.PaymentMethodDetails'
    },
    authorizationAgreement: {
        linkText: 'View Authorization Agreement',
        reviewText: 'Automatic Payments (Easy Pay) Authorization Agreement',
        verifyText: 'Check that you have read and accepted the terms of the Automatic Payments (Easy Pay) Authorization Agreement.',
        checkboxTermsAgreementText: 'I have read and agree to the terms of the agreement.'
    },
    claimConstants: {
        limit: 30,
        showMoreText: 'Load More',
        backToTop: 'Back To Top'
    },
    recurringPaymentsHelperText: {
        installmentFeesBankcard: 'Installment fees apply',
        installmentFeesEft: 'Reduced installment fees apply'
    },
    VALIDATORS: {
        accountNumber: [
            {
                keys: ['required'],
                value: 'Business billing account number is required'
            }, {
                keys: ['minlength', 'pattern'],
                value: 'Business billing account number is invalid'
            }
        ],
        minimumAmount: [
            {
                keys: ['required'],
                value: 'Full or minimum amount due is required'
            }, {
                keys: ['minlength', 'pattern'],
                value: 'Full or minimum amount due is invalid'
            }
        ],
        quickIdPolicyNumber: [
            {
                keys: ['required'],
                value: 'Business policy number is required'
            },
            {
                keys: ['minlength', 'pattern'],
                value: 'Business policy number is invalid'
            }
        ],
        zipCode: [
            {
                keys: ['required'],
                value: 'Business mailing ZIP code is required'
            },
            {
                keys: ['pattern', 'minlength'],
                value: 'Business mailing ZIP code is invalid'
            }
        ],
        lastName: [
            {
                keys: ['required'],
                value: 'Last name is required'
            },
            {
                keys: ['pattern'],
                value: 'Last name is invalid'
            }
        ],
        dateOfBirth: [
            {
                keys: ['required'],
                value: 'Date of birth is required'
            },
            {
                keys: ['minlength', 'pattern'],
                value: 'Check the date of birth format'
            },
            {
                keys: ['futureDate'],
                value: 'The date cannot be in the future'
            }
        ]
    },
    COI_VALIDATORS: {
        mainPak: [
            {
                keys: ['noSelection'],
                value: 'Main liability lines is required'
            }
        ],
        certHolderName: [
            {
                keys: ['required'],
                value: 'Certificate holder name is required'
            }
        ],
        address1: [
            {
                keys: ['required'],
                value: 'Address 1 is required'
            }
        ],
        city: [
            {
                keys: ['required'],
                value: 'City is required'
            }
        ],
        state: [
            {
                keys: ['required'],
                value: 'State is required'
            }
        ],
        zip: [
            {
                keys: ['required'],
                value: 'Zip is required'
            },
            {
                keys: ['pattern'],
                value: 'Zip is invalid'
            }
        ],
        contactName: [
            {
                keys: ['required'],
                value: 'Contact name is required'
            }
        ],
        contactPhoneNumber: [
            {
                keys: ['required'],
                value: 'Contact phone is required'
            },
            {
                keys: ['pattern'],
                value: 'Contact phone is invalid'
            }
        ],
        contactEmail: [
            {
                keys: ['required'],
                value: 'Contact email is required'
            },
            {
                keys: ['pattern'],
                value: 'Contact email is invalid'
            }
        ],
        deliveryEmail: [
            {
                keys: ['required'],
                value: 'Recipient email address(s) is required'
            }, {
                keys: ['emailLimit'],
                value: 'Please limit the number of emails to two.'
            }, {
                keys: ['pattern'],
                value: 'Recipient email is invalid'
            }
        ],
        deliveryFax: [
            {
                keys: ['required'],
                value: 'Fax number is required'
            },
            {
                keys: ['pattern'],
                value: 'Fax number is invalid'
            }
        ],
        recipientName: [
            {
                keys: ['required'],
                value: 'Recipient name is required'
            }
        ]
    },
    URLS: {
        accountSummary: '/account',
        billing: '/account/billing/',
        createAutomaticPayments: '/account/automaticPayments/create',
        createAutomaticPaymentsReview:
            '/account/automaticPayments/create/review',
        createAutomaticPaymentsConfirmation:
            '/account/automaticPayments/create/confirmation',
        cancelAutomaticPayments: '/account/automaticPayments/cancel',
        cancelAutomaticPaymentsReview:
            '/account/automaticPayments/cancel/review',
        suspendAutomaticPayments: '/account/automaticPayments/suspendAutomaticPayments',

        cancelAutomaticPaymentsConfirmation:
            '/account/automaticPayments/cancel/confirmation',
        suspendAutomaticPaymentsConfirmation:
            '/account/automaticPayments/suspendAutomaticPayments/confirmation',
        editAutomaticPayments: '/account/automaticPayments/edit',
        editAutomaticPaymentsReview: '/account/automaticPayments/edit/review',
        editAutomaticPaymentsConfirmation: '/account/automaticPayments/edit/confirmation',
        editCldAutomaticPayments: '/account/automaticPayments/cld-edit',
        editCldAutomaticPaymentsConfirmation: '/account/automaticPayments/cld-edit/confirmation',
        automaticPaymentsAuthorizationForm: '/account/automaticPayments/authorizationForm',
        policyClaimsList: '/commercial/claims/policy-claims-list',
        firstNoticeOfLoss: '/commercial/claims/first-notice-of-loss',
        claimsConfirmation: '/commercial/claims/confirmation',
        pakClaimsList: '/commercial/claims/pak-claims-list',
        oneTimePayment: '/account/payment',
        oneTimePayCLD: '/account/digital-payment',
        viewDocuments: '/account/viewDocuments',
        documents: '/account/documents/',
        quickPay: 'quickPay',
        requestCoi: 'account/requestCOI/',
        requestCoiReview: 'account/requestCOI/review',
        requestCoiSubmitted: 'account/requestCOI/submitted/',
        quickPaySearch: '/quickPay/search',
        quickPayPayment: '/quickPay/payment',
        quickPayWaysToPay: '/quickPay/quick-payment',
        quickPayReview: '../review',
        quickIdCardsSearch: '/quickIdCards',
        quickIdCardsView: '/quickIdCards/view',
        search: '../search',
        payment: '../payment',
        review: '../payment/review',
        confirmation: '../confirmation',
        digitalConfirmation: '/account/digital-confirmation',
        error500: '/error-500',
        stub: '/stub',
        claimOverview: '/commercial/claims/claim-overview',
        recurringPayment: '/recurring-payment-methods',
        currentRecurringPayment: '/recurring-payment-methods/current',
        allUpdates: '/commercial/claims/claim-overview/all-updates',
        incidentDetails: '/commercial/claims/claim-overview/incident-details',
        claimContacts: '/commercial/claims/claim-overview/claim-contacts',
        payments: '/commercial/claims/claim-overview/payments'
    },
    URL_REDIRECT: {
        paymentPreferencesTab: [
            '#/account',
            '#/account/automaticPayments/create',
            '#/account/automaticPayments/create/review',
            '#/account/automaticPayments/create/confirmation',
            '#/account/automaticPayments/edit',
            '#/account/automaticPayments/edit/review',
            '#/account/automaticPayments/edit/confirmation',
            '#/account/automaticPayments/cancel',
            '#/account/automaticPayments/cancel/confirmation',
            '#/account/automaticPayments/suspendAutomaticPayments',
            '#/account/automaticPayments/suspendAutomaticPayments/confirmation',
            '#/account/automaticPayments/cld-edit',
            '#/account/automaticPayments/cld-edit/confirmation'
        ],
        autopayPersistData: [
            '#/account/automaticPayments/edit/review',
            '#/account/automaticPayments/create/review'
        ],
        showAutopayAgreementPaymentData: [
            '#/account/billing/'
        ]
    },

    billingCenter: 'CL Direct',
    billingCenterSourceSystem: 'BC',
    billType: {
        pastBill: 'Previous.Bill',
        currentBill: 'Current.Bill'
    },
    paymentTechErrorCodes: {
        0: 'Go to confirmation page.',
        100: 'Please call us at 1-877-669-6877.',
        110: 'Please call us at 1-877-669-6877.',
        200: 'Name invalid.',
        300: 'Amount not specified or invalid value entered.',
        310: 'Credit card required.',
        315: 'Credit card required.',
        320: 'Credit card type left blank or invalid.',
        330: 'Expiration month left blank.',
        340: 'Expiration year left blank.',
        350: 'CVV2 field submitted but does not match the card.',
        355: 'CVV2 required but not present.',
        357: 'CVV invalid.',
        360: 'Your payment was declined. Please try another card or a different form of payment.',
        370: 'Expiration date invalid.',
        400: 'Please call us at 1-877-669-6877.',
        500: 'Address one field required but left blank.',
        510: 'City field required but left blank.',
        520: 'State field required but left blank.',
        530: 'Zip code invalid.',
        531: 'Invalid ZIP/postal code format received.',
        550: 'Country is missing.',
        600: 'The Bank name was blank (ECP Only).',
        610: 'The Routing Number is blank (ECP Only).',
        620: 'The Checking Account number was blank (ECP Only).',
        630: 'The Routing Number is invalid (ECP Only).',
        640: 'The Routing Number is invalid (ECP Only).'
    },
    INTERNET_DOCUMENT_UPLOAD: {
        DOC_ID: 'document0',
        DOC_TITLE: 'Request Letter for COI',
        FILE_TYPES: 'application/pdf,image/jpeg,image/gif,' +
            'image/tiff,image/x-tiff,image/x-windows-bmp,image/png,image/bmp,' +
            'image/pjpeg,application/vnd.openxmlformats-officedocument.wordprocessingml.document,' +
            'application/msword,application/docx',
        ALLOWED_FILE_SIZE: '3',
        MAX_FILE_SIZE: '4.5',
        FILE_LIMIT: '1'
    },
    AUTOPAY_RESPONSE_CODES: {
        PROCESSING: ['103', '115'],
        INELIGIBLE: ['104'],
        PENDING_ADD_UPDATE: ['105'],
        PENDING_REMOVE: ['114'],
        NO_AUTOPAY_SETUP: ['101']
    },
    AUTOPAY_ACTIONS: {
        ADD: 'ADD',
        UPDATE: 'UPDATE',
        REMOVE: 'REMOVE',
        SUSPEND: 'SUSPEND',
        PROCESSING: 'PROCESSING',
        PENDING_ADD_UPDATE: 'PENDING_ADD_UPDATE',
        PENDING_REMOVE: 'PENDING_REMOVE',
        PENDING_SUSPEND: 'PENDING_SUSPEND'
    },
    AUTOPAY_CTM_ACTIONS: {
        ADD: 'The customer signed up for Easy Pay automatic payments for billing account {billingAccountNumber}' +
            ', using payment method {accountType}. An email confirmation of this transaction was sent to {emailAddress}.',
        UPDATE: 'The customer updated their payment method {accountType} for Easy Pay automatic payments for billing account ' +
            '{billingAccountNumber}. An email confirmation of this transaction was sent to {emailAddress}.',
        REMOVE: 'The customer canceled and stopped Easy Pay automatic payments for billing account ' +
            '{billingAccountNumber}. An email confirmation of this transaction was sent to {emailAddress}.',
        SUSPEND: 'The customer suspended this month\'s Easy Pay automatic payment for billing account {billingAccountNumber}.' +
            ' An email confirmation of this transaction was sent to {emailAddress}.'
    },
    autoPayCtmEventIds: {
        ADD: 'InternetServicing-0032',
        UPDATE: 'InternetServicing-0033',
        REMOVE: 'InternetServicing-0034',
        SUSPEND: 'InternetServicing-0035'
    },
    EMAIL_TEMPLATES: {
        NAMES: {
            AUTOPAY_ADD: 'MYNW_COMMERCIAL_BEGIN_AUTO_PAY',
            AUTOPAY_UPDATE: 'MYNW_COMMERCIAL_UPDATE_AUTO_PAY',
            AUTOPAY_CANCEL: 'MYNW_COMMERCIAL_CANCEL_AUTO_PAY',
            AUTOPAY_SUSPEND: 'MYNW_COMMERCIAL_STOP_AUTO_PAY',
            CONFIRM_PAYMENT: 'MYNW_023_APPLY_PAYMENT'
        },
        REQUESTER_NAME: 'DGS_Self_Servicing',
        DOC_TYPE: 'ACORD 25'
    },

    MONEY_PROCESSING: {
        RETRIEVE_SAVED_PAYMENT_METHODS: `Money Processing - Retrieve Saved Payment Methods`,
        RETRIEVE_SAVED_PAYMENT_METHODS_ERROR: `Error retrieving saved paymet methods with URL:`,
        SAVE_PAYMENT_METHOD: `Money Processing - Save Pay Method`,
        SAVE_PAYMENT_METHOD_ERROR: 'Error while save the payment methods with URL:',
        UPDATE_PAYMENT_METHOD: `Money Processing - Update Pay Method`,
        UPDATE_PAYMENT_METHOD_ERROR: `Error while update the payment methods with URL:`,
        RETRIEVE_SINGLE_SAVED_PAYMENT_METHOD: 'Money Processing - Retrieve Single Saved Payment Method'
    },

    NUMBERS: {
        THREE: 3,
        FOUR: 4,
        EIGHT: 8,
        THOUSAND: 1000
    },

    SAVED_PAYMENT_METHOD: {
        MESSAGES: {
            DUPLICATE: 'The payment method you are trying to add already exists.',
            UPDATE_SUCCESS: 'Your payment method has been updated',
            SAVE_SUCCESS: 'Your payment method has been saved',
            SERVICE_DOWN_SAVE: `We're sorry, we could not add your payment method. Please try again later.`,
            SERVICE_DOWN_UPDATE: `We're sorry, we could not update your payment method. Please try again later.`
        }
    },

    NACHA_VERIFICATION: {
        MULTI_ATTEMPTS_ERROR_RESPONSE_CODE: 429
    },

    CREDIT_LIMIT: 25000.00,

    BANK_CARD_LIMIT: +99999.99,

    FUNDING_CIRCLE_INFO: {
        BUTTON_TEXT: 'Explore funding options'
    },

    FILTERED_KEYS_ARRAY: [
        'length',
        'id_token',
        'id_token_claims_obj',
        'nwcs',
        'claimNavigationData',
        'camAuthConfig'
    ],

    TEST_ENVS: [
        'a',
        'b',
        'atlantis',
        'testlearn',
        'garret',
        'mike',
        'roman',
        'surya',
        'tony',
        'david',
        'joann',
        'bazil'
    ],

    packageInfo: [
        {
            prefixes: [
                'ACP',
                'BAN',
                'BAL',
                'BA',
                'CAS',
                'BAA',
                'BAPC',
                'BAPD',
                'BAK',
                'BAF',
                'BAG'
            ],
            display: 'Business Auto',
            tridionIdentifier: 'businessAuto',
            mobileIcon: 'comm-business-auto'
        },
        {
            prefixes: [
                'BPA',
                'BPAF',
                'BPAD',
                'GPA',
                'AGPA',
                'BP_'
            ],
            display: 'Businessowners',
            tridionIdentifier: 'autoService',
            mobileIcon: 'comm-auto-service'
        },
        {
            prefixes: [
                'BPF',
                'BP_F'
            ],
            display: 'Businessowners',
            tridionIdentifier: 'foodservice',
            mobileIcon: 'comm-food-service'
        },
        {
            prefixes: [
                'BPH',
                'BP_C'
            ],
            display: 'Businessowners',
            tridionIdentifier: 'habitational',
            mobileIcon: 'comm-office' // using comm-office icon since it has no specific habitational icon
        },
        {
            prefixes: [
                'BPM',
                'BOS',
                'BP_L'
            ],
            display: 'Businessowners',
            tridionIdentifier: 'hotel',
            mobileIcon: 'comm-hotel'
        },
        {
            prefixes: ['BPO', 'BP01', 'BP_D'],
            display: 'Businessowners',
            tridionIdentifier: 'office',
            mobileIcon: 'comm-office'
        },
        {
            prefixes: [
                'BPS',
                'BBS',
                'BP_M'
            ],
            display: 'Businessowners',
            tridionIdentifier: 'processService',
            mobileIcon: 'comm-process-service'
        },
        {
            prefixes: ['BPR', 'BP_K'],
            display: 'Businessowners',
            tridionIdentifier: 'retail',
            mobileIcon: 'comm-retail'
        },
        {
            prefixes: ['BPW', 'BP_G'],
            display: 'Businessowners',
            tridionIdentifier: 'wholesalers',
            mobileIcon: 'comm-wholesale'
        },
        {
            prefixes: [
                'CA',
                'CAA',
                'CAF',
                'CAMK',
                'CAMD',
                'CU'
            ],
            display: 'Commercial Umbrella',
            tridionIdentifier: 'commercialUmbrella',
            mobileIcon: 'comm-umbrella'
        },
        {
            prefixes: [
                'CIM',
                'CIMN',
                'PES',
                'CIMP',
                'CI'
            ],
            display: 'Inland Marine',
            tridionIdentifier: 'commercialInlandMarine',
            mobileIcon: 'comm-inland-marine'
        },
        {
            prefixes: [
                'CO',
                'COPA',
                'COPK'
            ],
            display: 'Commercial Output',
            tridionIdentifier: 'commercialOutput',
            mobileIcon: 'comm-farm' // no image for commercial output, that's why adding farm image
        },
        {
            prefixes: [
                'CPPN',
                'EQ',
                'CPP',
                'CPAA',
                'CPPP',
                'CPPD',
                'CPPK',
                'EQ ONLY',
                'CPPF',
                'COPZ'
            ],
            display: 'Commercial Property',
            tridionIdentifier: 'commercialProperty',
            mobileIcon: 'comm-office2' // no image for commercial property,that's why adding office2 image
        },
        {
            prefixes: ['CR'],
            display: 'Crime',
            tridionIdentifier: 'crime'
        },
        {
            prefixes: [
                'FAEN'
            ],
            display: 'Farm Umbrella',
            tridionIdentifier: 'farmUmbrella',
            mobileIcon: 'comm-farm-umbrella'
        },
        {
            prefixes: ['FMPN', 'FMPP', 'FMPA'],
            display: 'Farm Property',
            tridionIdentifier: 'farmProperty',
            mobileIcon: 'comm-farm-prop'
        },
        {
            prefixes: [
                'FMP',
                'FLC',
                'FLN',
                'FLA',
                'FL',
                'FR',
                'LM',
                'BTFA',
                'BTFC',
                'PPA',
                'FA01'
            ],
            display: 'Farm',
            tridionIdentifier: 'farmLiability',
            mobileIcon: 'comm-farm-liability'
        },
        {
            prefixes: [
                'GLNO',
                'GLO',
                'GLAO',
                'KNK',
                'GLPO',
                'GLDO',
                'GLKO',
                'GLGO',
                'CG'
            ],
            display: 'General Liability',
            tridionIdentifier: 'generalLiabilityCommercial',
            mobileIcon: 'comm-gen-liability'
        },
        {
            prefixes: [
                'WCN',
                'WC',
                'WCS',
                'WCA',
                'WCP',
                'WCD',
                'WCK',
                'WCF'
            ],
            display: 'Workers Compensation',
            tridionIdentifier: 'workersCompensation',
            mobileIcon: 'comm-workers-comp'
        },
        {
            prefixes: ['CRMP', 'CRM'],
            display: 'Crime',
            mobileIcon: 'comm-workers-comp' // We got no image for Crime, so using WorkersCompensation icon
        }
    ],
    ALLOWED_PARAMS: [
        'accountDetails',
        'accountNumber',
        'autopayDetails',
        'balanceDetails',
        'billingAccountNumber',
        'canMakeAPayment',
        'channel',
        'chatInitiated',
        'claimNavigationData',
        'claimsPakNumber',
        'claimsPolicyType',
        'claimsSelectedAccountNumber',
        'claimsSelectedPolicyNumber',
        'cldPaymentAmount',
        'coiData',
        'commercial.authenticatedFlag',
        'emailAddress',
        'enterpriseCustomerNumber',
        'fileUploadStatus',
        'firstName',
        'fnolFlow',
        'fullName',
        'isBillingCenter',
        'isFlexAccount',
        'iscomm_access_token',
        'iscomm_access_token_expires_at',
        'iscomm_access_token_expires_in',
        'iscomm_id_token',
        'iscomm_refresh_token',
        'lastName',
        'namedInsured',
        'namedInsuredName',
        'payDueDate',
        'paymentData',
        'paymentDetails',
        'paymentType',
        'previousHash',
        'previousUrl',
        'quickIdCardPolicyNumber',
        'referringPage',
        'sessionId',
        'showC2C',
        'state',
        'stubbed',
        'targetEnvironment',
        'uploadedFileName',
        'useValidator',
        'userId',
        'viewDocumentDetails'
    ]
};
